import {createFileRoute} from '@tanstack/react-router'

import {RentalAssetTypeDetailsPage} from '../../../../assets/rental-assets/rental-asset-type-details-page'

export const Route = createFileRoute('/_app/rental-assets/types/$typeId')({
    component: RentalAssetTypeDetailsRoute,
})

function RentalAssetTypeDetailsRoute() {
    const {typeId} = Route.useParams()

    return <RentalAssetTypeDetailsPage typeId={typeId} />
}
